<template>
  <div>
    <wc-section-title title='Calendars' :loading='isLoading'></wc-section-title>
    <router-view v-if='calendar' :loading='isLoading' :calendar='calendar'></router-view>
  </div>
</template>

<script>
import scheduleAPI from '@/modules/schedule/api/schedule'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'calendars-base',
  data: () => ({
    isLoading: false,
    calendar: null,
    activeCalendars: [],
    activeSchedules: [],
    subNav: [],
    extraNav: [],
  }),
  computed: {
    today () {
      return moment().format('YYYY-MM-DD').toString()
    }
  },
  mounted () {
    // this.$store.state.nav.showDrawer = false
    this.selected = []
    this.getData()
  },
  beforeRouteLeave (to, from, next) {
    // this.$store.state.nav.showDrawer = true
    this.$store.dispatch('clearSubnav')
    this.$store.dispatch('clearExtraNav')
    next()
  },
  // beforeRouteUpdate (to, from, next) {
  //   this.getData(to.params.id)
  //   next()
  // },
  methods: {
    async getData () {
      this.isLoading = true
      this.subNav = []
      this.extraNav = []
      let tmp = await scheduleAPI.getSchedules()
      this.activeSchedules = _.filter(tmp, s => s.is_archived === false && s.division)
      this.activeCalendars = _.filter(tmp, s => s.is_archived === false && !s.division)
      this.calendar = _.find(tmp, s => s.id == this.$route.params.id)
      this.activeSchedules.forEach(s => {
        this.subNav.push({
          title: s.name,
          icon: _.find(this.$store.state.misc.divisions, d => d.id == s.division).icon,
          route: { name: 'ScheduleDay', params: { id: s.id, date: moment().format('YYYY-MM-DD').toString() } }
        })
      })
      this.activeCalendars.forEach(c => {
        this.extraNav.push({
          title: c.name,
          icon: 'mdi-calendar',
          route: { name: 'OfficeCalendar', params: { id: c.id, date: moment().format('YYYY-MM-DD').toString() } }
        })
      })
      if (this.subNav.length) {
        this.$store.dispatch('loadSubnavTitle', 'Work Order Schedules')
        this.$store.dispatch('loadSubnav', this.subNav)
      }
      if (this.extraNav.length) {
        this.$store.dispatch('loadExtraNavTitle', 'Calendars')
        this.$store.dispatch('loadExtraNav', this.extraNav)
      }
      this.isLoading = false
    }
  },
  components: {
    
  }
}
</script>
